import React, { Component } from "react";
import { connect } from "react-redux";

import ColorSetter from "./NewColorPicker";
import ImageUploader from "./ImageUploader";

import { TextField, Select } from "./FormElements";
import Icon from "./Icons";
import { validURL, l } from "../functions";
import axios from "axios";
import { ajaxUri } from "../consts/index";
import SliderRange from "./SliderRange";
import GKEvent from "../events";
import { RemoveShoppingCartSharp } from "@material-ui/icons";

const mapStateToProps = (state) => {
  return {
    fetchedLangs: state.rootReducer.fetchedLangs || [],
    currentLang: state.rootReducer.currentLang || 1,
  };
};
class PageDialog extends Component {
  constructor(props) {
    super(props);

    this.defaultState = {
      EZCONF_ENABLE_FLOAT_CHECKOUT: "",
      EZCONF_NEW_ORDER_ID: "",
      EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL: "",
      error: "",
      previous_order_id: 0,
      save_button: false,
    };

    this.state = this.defaultState;
    this.reservedURLS = [
      "terms-and-conditions",
      "privacy-policy",
      "shipping-policy",
      "refund-policy",
    ];

    this.fields = [
      {
        id: "meta_title",
        label: l("Title"),
        multiline: false,
        multilang: true,
        solid: true,
      },
      {
        id: "meta_keywords",
        label: l("Keywords"),
        multiline: true,
        multilang: true,
        solid: true,
      },
      {
        id: "meta_description",
        label: l("Description"),
        multiline: true,
        multilang: true,
        solid: true,
      },
      {
        id: "link_rewrite",
        label: l("Friendly URL"),
        multiline: false,
        pageType: "cms",
        multilang: true,
        solid: true,
      },
      { hr: true },
    ];

    if (this.props.currentPage && this.props.currentPage.key === "checkout")
      this.fields.push(
        ...[
          { globalSettings: "EZCONF_ENABLE_FLOAT_CHECKOUT" },
          { globalSettings: "EZCONF_NEW_ORDER_ID" },
          { globalSettings: "EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL" },
          { hr: true },
        ]
      );

    this.fields.push(
      ...[
        {
          id: "background",
          background: true,
        },
        { hr: true },
        { title: l("Code Includes (Tracking, GA, etc…)") },
      ]
    );

    if (this.props.currentPage && this.props.currentPage.key === "thankyou")
      this.fields.push(
        ...[
          {
            message: l(
              "Javascript variables:<br />Total cart value: <strong>total_paid_tax_excl</strong><br />Order number: <strong>id_thanks_order</strong>"
            ),
          },
        ]
      );

    this.fields.push(
      ...[
        {
          id: "pageScriptHead",
          label: l("HTML <head>"),
          multiline: true,
        },
        {
          id: "pageScriptBodyBefore",
          label: l("HTML <body> top"),
          multiline: true,
        },
        {
          id: "pageScriptBodyAfter",
          label: l("HTML <body> bottom"),
          multiline: true,
        },
      ]
    );

    if (this.props.currentPage?.key === "home") {
      this.fields.push(
        ...[
          { hr: true },
          { title: l("Open Graph (Social Share) Settings") },
          {
            id: "og_image",
          },
          {
            id: "og_title",
            label: l("OG Title"),
            multiline: true,
          },
          {
            id: "og_desc",
            label: l("OG Description"),
            multiline: true,
          },
        ]
      );
    }
  }

  _generateOGImageUploader = () => {
    const ogSettings =
      (this.props.pageDatas && this.props.pageDatas.og_image) || {};
    return (
      <div>
        <div className="section">
          <ImageUploader
            title={l("OG Image")}
            buttonText={l("Upload image")}
            onChange={(url) => {
              this._changedSettingsOG("og_image", "og_imageURL", url);
            }}
            imgExtension={[".jpg", ".gif", ".png", ".gif", "webp"]}
            maxFileSize={5242880}
            withPreview={true}
            singleImage={true}
            defaultImages={
              ogSettings &&
              ogSettings.og_imageURL !== undefined &&
              ogSettings.og_imageURL !== null
                ? ogSettings.og_imageURL
                : ""
            }
          />
        </div>
      </div>
    );
  };
  _changedSettingsOG = (indexOne, indexTwo, value = 0) => {
    const ogSettings =
      (this.props.pageDatas && this.props.pageDatas.og_image) || {};
    const objectValue = {
      ...ogSettings,
      [indexTwo]: value,
    };
    this.props.onChange(indexOne, objectValue);
  };

  _changedSettingsTwo = (indexOne, indexTwo, value = 0) => {
    const backgroundSettings =
      (this.props.pageDatas && this.props.pageDatas.background) || {};

    const objectValue = {
      ...backgroundSettings,
      [indexTwo]: value,
    };

    this.props.onChange(indexOne, objectValue);
  };

  _generateLangTextField = (field) => {
    return (
      this.props.fetchedLangs &&
      this.props.fetchedLangs.map(
        (lang, index) =>
          this.props.currentLang == lang.value && (
            <div className="section" key={index}>
              <TextField
                label={field.label}
                solid={field.solid}
                size="small"
                onChange={(value) => {
                  if (field.id === "link_rewrite") {
                    if (this.reservedURLS.includes(value)) {
                      this.setState({ error: "URL already in use" });
                    } else {
                      this.setState({ error: null });
                    }
                  }
                  this.props.onChange(field.id + "_" + lang.value, value);
                }}
                multiline={field.multiline}
                // info={lang.name}
                dark
                value={
                  (this.props.pageDatas &&
                    this.props.pageDatas[field.id + "_" + lang.value]) ||
                  ""
                }
                error={
                  field.id === "link_rewrite" &&
                  (this.state.error ||
                    (this.reservedURLS.includes(
                      this.props.pageDatas &&
                        this.props.pageDatas[field.id + "_" + lang.value]
                    )
                      ? "URL already in use "
                      : ""))
                }
              />
            </div>
          )
      )
    );
  };

  _generateBackgroundField = (field, key) => {
    const backgroundSettings =
      (this.props.pageDatas && this.props.pageDatas[field.id]) || {};
    return (
      <div>
        <div className="section">
          <ImageUploader
            title={l("Background image")}
            buttonText={l("Upload image")}
            onChange={(url) => {
              this._changedSettingsTwo("background", "backgroundImage", url);
            }}
            imgExtension={[".jpg", ".gif", ".png", ".gif", ".webp"]}
            maxFileSize={5242880}
            withPreview={true}
            singleImage={true}
            defaultImages={
              backgroundSettings &&
              backgroundSettings.backgroundImage !== undefined &&
              backgroundSettings.backgroundImage !== null
                ? backgroundSettings.backgroundImage
                : ""
            }
          />
        </div>
        <div className="section">
          <div className="gk-form-row-container">
            <label className="small">{l("Background color")}</label>
            <ColorSetter
              color={
                (backgroundSettings && backgroundSettings.backgroundColor) || ""
              }
              onChangeComplete={(color) => {
                this._changedSettingsTwo(
                  "background",
                  "backgroundColor",
                  color
                );
              }}
            />
          </div>
        </div>
        {backgroundSettings && backgroundSettings.backgroundImage && (
          <div className="section">
            <div className="gk-form-row-container">
              <label className="small">{l("Repeat")}</label>
              <Select
                value={backgroundSettings.backgroundRepeat || "repeat"}
                onChange={(value) => {
                  this._changedSettingsTwo(
                    "background",
                    "backgroundRepeat",
                    value
                  );
                }}
                options={[
                  {
                    label: l("Repeat"),
                    value: "repeat",
                  },
                  {
                    label: l("Repeat X"),
                    value: "repeat-x",
                  },
                  {
                    label: l("Repeat Y"),
                    value: "repeat-y",
                  },
                  {
                    label: l("No repeat"),
                    value: "no-repeat",
                  },
                ]}
                dark
              />
            </div>
          </div>
        )}
        {backgroundSettings && backgroundSettings.backgroundImage && (
          <div className="section">
            <div className="gk-form-row-container">
              <label className="small">{l("Size")}</label>
              <ul className="inline-options dark">
                <li
                  className={
                    backgroundSettings.backgroundSize === "initial"
                      ? "selected"
                      : ""
                  }
                  onClick={() => {
                    this._changedSettingsTwo(
                      "background",
                      "backgroundSize",
                      "initial"
                    );
                  }}
                >
                  <span>{l("Auto")}</span>
                </li>
                <li
                  className={
                    backgroundSettings.backgroundSize === "cover"
                      ? "selected"
                      : ""
                  }
                  onClick={() => {
                    this._changedSettingsTwo(
                      "background",
                      "backgroundSize",
                      "cover"
                    );
                  }}
                >
                  <span>{l("Cover")}</span>
                </li>
                <li
                  className={
                    backgroundSettings.backgroundSize === "contain"
                      ? "selected"
                      : ""
                  }
                  onClick={() => {
                    this._changedSettingsTwo(
                      "background",
                      "backgroundSize",
                      "contain"
                    );
                  }}
                >
                  <span>{l("Contain")}</span>
                </li>
              </ul>
            </div>
          </div>
        )}
        {backgroundSettings && backgroundSettings.backgroundImage && (
          <div className="section">
            <div className="gk-form-row-container">
              <label className="small">{l("Align")}</label>
              <div className="gk-bg-align-box">
                <div>
                  <Icon
                    className={
                      backgroundSettings.backgroundPosition == "left top"
                        ? "active"
                        : ""
                    }
                    icon="align-top-left"
                    onClick={() => {
                      this._changedSettingsTwo(
                        "background",
                        "backgroundPosition",
                        "left top"
                      );
                    }}
                  />
                  <Icon
                    className={
                      backgroundSettings.backgroundPosition == "center top"
                        ? "active"
                        : ""
                    }
                    icon="align-top-center"
                    onClick={() => {
                      this._changedSettingsTwo(
                        "background",
                        "backgroundPosition",
                        "center top"
                      );
                    }}
                  />
                  <Icon
                    className={
                      backgroundSettings.backgroundPosition == "right top"
                        ? "active"
                        : ""
                    }
                    icon="align-top-right"
                    onClick={() => {
                      this._changedSettingsTwo(
                        "background",
                        "backgroundPosition",
                        "right top"
                      );
                    }}
                  />
                </div>
                <div>
                  <Icon
                    className={
                      backgroundSettings.backgroundPosition == "left center"
                        ? "active"
                        : ""
                    }
                    icon="align-middle-left"
                    onClick={() => {
                      this._changedSettingsTwo(
                        "background",
                        "backgroundPosition",
                        "left center"
                      );
                    }}
                  />
                  <Icon
                    className={
                      backgroundSettings.backgroundPosition ==
                        "center center" ||
                      !backgroundSettings.backgroundPosition
                        ? "active"
                        : ""
                    }
                    icon="align-middle-center"
                    onClick={() => {
                      this._changedSettingsTwo(
                        "background",
                        "backgroundPosition",
                        "center center"
                      );
                    }}
                  />
                  <Icon
                    className={
                      backgroundSettings.backgroundPosition == "right center"
                        ? "active"
                        : ""
                    }
                    icon="align-middle-right"
                    onClick={() => {
                      this._changedSettingsTwo(
                        "background",
                        "backgroundPosition",
                        "right center"
                      );
                    }}
                  />
                </div>
                <div>
                  <Icon
                    className={
                      backgroundSettings.backgroundPosition == "left bottom"
                        ? "active"
                        : ""
                    }
                    icon="align-bottom-left"
                    onClick={() => {
                      this._changedSettingsTwo(
                        "background",
                        "backgroundPosition",
                        "left bottom"
                      );
                    }}
                  />
                  <Icon
                    className={
                      backgroundSettings.backgroundPosition == "center bottom"
                        ? "active"
                        : ""
                    }
                    icon="align-bottom-center"
                    onClick={() => {
                      this._changedSettingsTwo(
                        "background",
                        "backgroundPosition",
                        "center bottom"
                      );
                    }}
                  />
                  <Icon
                    className={
                      backgroundSettings.backgroundPosition == "right bottom"
                        ? "active"
                        : ""
                    }
                    icon="align-bottom-right"
                    onClick={() => {
                      this._changedSettingsTwo(
                        "background",
                        "backgroundPosition",
                        "right bottom"
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  _getSetting = (key) => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "getSetting",
        key: key,
      },
    })
      .then((result) => {
        if (key === "EZCONF_NEW_ORDER_ID") {
          this.setState({
            [key]: result.data,
            previous_order_id: result.data,
          });
        } else {
          this.setState({
            [key]: result.data,
          });
        }
      })
      .catch((error) => {
        GKEvent.notification("error", l("Error."));
      });
  };

  componentDidMount() {
    if (this.props.currentPage && this.props.currentPage.key === "checkout") {
      const settings = [
        "EZCONF_ENABLE_FLOAT_CHECKOUT",
        "EZCONF_NEW_ORDER_ID",
        "EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL",
      ];

      settings.forEach((key) => {
        this._getSetting(key);
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentPage && nextProps.currentPage.key === "checkout") {
      const settings = [
        "EZCONF_ENABLE_FLOAT_CHECKOUT",
        "EZCONF_NEW_ORDER_ID",
        "EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL",
      ];

      settings.forEach((key) => {
        this._getSetting(key);
      });
    }
  }

  render() {
    if (this.props.fields) {
      this.fields = this.props.fields;
    }
    return (
      <div className="page-dialog">
        <div className="head">
          <h3>
            {this.props.currentPage && l("Edit page")}
            {this.props.newPage && l("New custom page")}
            {this.props.unsaved ? "*" : ""}
          </h3>
          <div className="buttons">
            <button
              className="new-item"
              onClick={() => {
                if (
                  this.state.error ||
                  this.state.previous_order_id > this.state.EZCONF_NEW_ORDER_ID
                ) {
                  return;
                }
                this.props.onSubmit(this.state);
                // this.setState(this.defaultState);
              }}
              disabled={this.state.save_button}
            >
              <Icon icon="check" />
            </button>
            <div>
              <Icon icon="time" onClick={this.props.onClose} />
            </div>
          </div>
        </div>
        <div className="form">
          {this.fields.map((field, index) => {
            const showField =
              (field.pageType && this.props.pageType === field.pageType) ||
              !field.pageType;
            if (showField)
              return (
                (field.br && <br key={index} />) ||
                (field.hr && <hr key={index} />) ||
                (field.title && (
                  <label key={index} className="small">
                    {field.title}
                  </label>
                )) ||
                (field.message && (
                  <div key={index} className="gk-custom-message">
                    <p dangerouslySetInnerHTML={{ __html: field.message }}></p>
                  </div>
                )) ||
                (field.multilang && (
                  <div key={index}>{this._generateLangTextField(field)}</div>
                )) ||
                (field.background && (
                  <div key={index}>
                    {this._generateBackgroundField(field, index)}
                  </div>
                )) ||
                (field.id === "og_image" && this._generateOGImageUploader()) ||
                (field.globalSettings && (
                  <div key={index} className="section">
                    {field.globalSettings ===
                      "EZCONF_ENABLE_FLOAT_CHECKOUT" && (
                      <label className="small">
                        {l('"Add to cart" click action')}
                      </label>
                    )}
                    {field.globalSettings ===
                      "EZCONF_ENABLE_FLOAT_CHECKOUT" && (
                      <Select
                        dark
                        value={this.state.EZCONF_ENABLE_FLOAT_CHECKOUT.toString()}
                        onChange={(value) =>
                          this.setState({ EZCONF_ENABLE_FLOAT_CHECKOUT: value })
                        }
                        placeholder={l("Please select")}
                        options={[
                          { label: l("Redirect to checkout page"), value: "0" },
                          { label: l("Flyout Cart"), value: "1" },
                          { label: l("Popup Cart"), value: "2" },
                        ]}
                      />
                    )}
                    {field.globalSettings === "EZCONF_NEW_ORDER_ID" && (
                      <>
                        <label className="small">
                          {l("Starting Order Number")}
                        </label>
                        {!(
                          this.state.previous_order_id <=
                          this.state.EZCONF_NEW_ORDER_ID
                        ) && (
                          <div className="gk-error-message">
                            <p>
                              {l(
                                "The New Starting order Number can not be smaller than previously set number."
                              )}
                            </p>
                          </div>
                        )}
                      </>
                    )}
                    {field.globalSettings === "EZCONF_NEW_ORDER_ID" && (
                      <SliderRange
                        value={
                          this.state.EZCONF_NEW_ORDER_ID ||
                          this.state.previous_order_id ||
                          1
                        }
                        min={1}
                        max={9999}
                        onChange={(value) => {
                          if (!(this.state.previous_order_id <= value)) {
                            this.setState({
                              EZCONF_NEW_ORDER_ID: value,
                              save_button: true,
                            });
                          } else {
                            this.setState({
                              EZCONF_NEW_ORDER_ID: value,
                              save_button: false,
                            });
                          }
                        }}
                      />
                    )}
                    {field.globalSettings ===
                      "EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL" && (
                      <label className="small">
                        {l("Custom thank you page URL")}
                      </label>
                    )}
                    {field.globalSettings ===
                      "EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL" && (
                      <div className="gk-error-message">
                        <p>
                          {l(
                            "After Buyer lands on default thank you page he will be redirected to a custom thank you page in 5 seconds. Leave it blank if you do not want to redirect Buyer anywhere from default thank you page."
                          )}
                        </p>
                      </div>
                    )}
                    {field.globalSettings ===
                      "EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL" && (
                      <TextField
                        placeholder={l("Thank you page URL")}
                        value={this.state.EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL}
                        onChange={(value) =>
                          this.setState({
                            EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL: value,
                          })
                        }
                        dark
                        error={
                          !validURL(
                            this.state.EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL || ""
                          )
                            ? l("Url format not correct")
                            : false
                        }
                      />
                    )}
                  </div>
                )) || (
                  <div key={index} className="section">
                    <TextField
                      label={(field.solid && field.label) || null}
                      solid={field.solid}
                      placeholder={(!field.solid && field.label) || null}
                      value={
                        (this.props.pageDatas &&
                          this.props.pageDatas[field.id]) ||
                        ""
                      }
                      onChange={(value) => {
                        this.props.onChange(field.id, value);
                      }}
                      multiline={field.multiline}
                      size="small"
                      dark
                    />
                  </div>
                )
              );
          })}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(PageDialog);
